var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('headline',{attrs:{"isCollapse":_vm.isCollapse},on:{"Collapse":_vm.checkCollapse}}),_c('el-aside',{staticStyle:{"width":"auto"}},[_c('aside-menu',{attrs:{"isCollapse":_vm.isCollapse}})],1),_c('el-main',{class:{ 'collapse-left': _vm.isCollapse }},[_c('tabs',{ref:"tabs"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }